import { useTranslation } from 'react-i18next'

import { Button } from '@dfds-pax/shared-components/client'

interface Props {
  onClick: () => void
}

const OverlayFooter: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()

  return (
    <div className="fixed bottom-0 left-0 right-0 mt-auto flex flex-col justify-center bg-white lg:hidden" id="footer-content">
      <div className="border-0 border-b border-solid border-gray-300" />
      <div className="box-border flex w-full flex-col p-semantic-global-md">
        <Button fullWidth onClick={onClick}>
          {t('APPLY')}
        </Button>
      </div>
    </div>
  )
}

export default OverlayFooter
